import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=3b1a4bee&scoped=true&"
import script from "./todoList.vue?vue&type=script&lang=js&"
export * from "./todoList.vue?vue&type=script&lang=js&"
import style0 from "./todoList.vue?vue&type=style&index=0&id=3b1a4bee&prod&scoped=true&lang=css&"
import style1 from "./todoList.vue?vue&type=style&index=1&id=3b1a4bee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a4bee",
  null
  
)

export default component.exports